import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=dc91a2ec&scoped=true&lang=pug"
import script from "./SearchView.vue?vue&type=script&lang=ts"
export * from "./SearchView.vue?vue&type=script&lang=ts"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=dc91a2ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc91a2ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc91a2ec')) {
      api.createRecord('dc91a2ec', component.options)
    } else {
      api.reload('dc91a2ec', component.options)
    }
    module.hot.accept("./SearchView.vue?vue&type=template&id=dc91a2ec&scoped=true&lang=pug", function () {
      api.rerender('dc91a2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Search/SearchView.vue"
export default component.exports